import { apiService } from "@/services/api.service";
import router from "@/router";
import { State, User } from "./state";

// User object containing username, jwt token and additional information
const user = JSON.parse(localStorage.getItem("user") as string);

const state = user
  ? { status: { loggedIn: true, unreadMsg: false, alert: {} as any }, user }
  : { status: { unreadMsg: false, alert: {} as any }, user: null };

const actions = {
  handleRequestError({ dispatch, commit }, error) {
    commit("error", error.error);
  },
  printAlertMessage({ dispatch, commit }, msg) {
    commit("success", msg.msg ? msg.msg : msg);
  },
  // @ts-ignore
  login({ dispatch, commit }, { username, password, target, errorHandler }) {
    commit("loginRequest", { username });
    apiService.login(username, password).then(
      user => {
        commit("loginSuccess", user);
        if (!target || target.indexOf("login") != -1) router.push("/");
        else router.push(target);
      },
      error => {
        commit("loginFailure", error.error);
        commit("error", error.error, { root: true });
        errorHandler(error);
      }
    );
  },
  clear({ dispatch, commit }) {
    commit("clear", { root: true });
  },
  cancel({ dispatch, commit }) {
    console.log("got cancel req");
    commit("cancelLogin", "");
  },
  // @ts-ignore
  logout({ commit }) {
    apiService.logout();
    commit("logout");
  },
  // @ts-ignore
  register(
    { dispatch, commit },
    { user, suppressAlert, errorCallback, successCallback }
  ) {
    commit("registerRequest", user);

    apiService.register(user).then(
      user => {
        commit("registerSuccess", user);
        successCallback();
      },
      errorObject => {
        const error = errorObject.error;
        const additionalInformation = errorObject.additionalInformation;
        commit("registerFailure", error);

        if (!suppressAlert) commit("error", error, { root: true });

        if (additionalInformation) {
          errorCallback(additionalInformation);
        }
      }
    );
    // @ts-ignore
  },
  activateUser({ dispatch, commit }, { code }) {
    return apiService.activateUser(code);
  },
  listDatasets({ dispatch, commit }) {
    return apiService.listDatasets();
  },
  listPendingRequests({ dispatch, commit }) {
    return apiService.listPendingRequests();
  },
  listPendingLinkActivation({ dispatch, commit }) {
    return apiService.listPendingLinkActivation();
  },
  listPendingPackageRequests({ disptach, commit }) {
    return apiService.listPendingPackageRequests();
  },
  activatePendingRequest({ dispatch, commit }, { userId }) {
    return apiService.activatePendingRequest(userId);
  },
  grantAccessForPackageRequest({ dispatch, commit }, { userId, packageId }) {
    console.log("grant accesss");
    console.log(userId, packageId);
    return apiService.grantAccessForPackageRequest(userId, packageId);
  },
  grantAccessForRoleRequest({ dispatch, commit }, { userId, roleId }) {
    return apiService.grantAccessForRoleRequest(userId, roleId);
  },
  addNewPackage({ dispatch, commit }, { newPackage }) {
    return apiService.addNewPackage(newPackage);
  },
  getAllPackages({ dispatch, commit }) {
    return apiService.getAllPackages();
  },
  getPackagesForUser({ dispatch, commit }) {
    return apiService.getPackagesForUser();
  },
  getAllRoles() {
    return apiService.getAllRoles();
  },
  submitRoleChanges({ dispatch, commit }, changedRole) {
    return apiService.submitRoleChanges(changedRole);
  },
  getUsers() {
    return apiService.getUsers();
  },
  addRoleToUser({ dispatch, commit }, { id, role }) {
    return apiService.addRoleToUser(id, role);
  },
  removeRoleFromUser({ dispatch, commit }, { id, role }) {
    return apiService.removeRoleFromUser(id, role);
  },
  requestPackage({ dispatch, commit }, { packageId, reason }) {
    console.log("id", packageId, "rs", reason);
    return apiService.requestPackage(packageId, reason);
  },
  requestRole({ dispatch, commit }, { role, reason }) {
    return apiService.requestRole(role, reason);
  },
  getSubmissions() {
    return apiService.getSubmissions();
  },
  getSubmissionsForId({ disptach, commit }, { id }) {
    return apiService.getSubmissionsForId(id);
  },
  changeSubmissionState({ dispatch, commit }, { subId, visible }) {
    return apiService.changeSubmissionState(subId, visible);
  },
  getBenchmark({ dispatch, commit }, challenge) {
    return apiService.getBenchmark(challenge);
  },
  changePassword({ dispatch, commit }, { OTP, password }) {
    return apiService.changePassword(OTP, password);
  },
  requestNewPassword({ dispatch, commit }, username) {
    return apiService.requestNewPassword(username);
  },
  requestUsername({ dispatch, commit }, email) {
    return apiService.requestUsername(email);
  },
  getAdminBenchmark({ dispatch, commit }, challenge) {
    return apiService.getAdminBenchmark(challenge);
  },
  checkUserAllowedToSubmit({ dispatch, commit }, { challenge, task }) {
    return apiService.checkUserAllowedToSubmit(challenge, task);
  },
  getMD5ForPackage({ dispatch, commit }, packageId) {
    return apiService.getMD5ForPackage(packageId);
  },
  updateSubmission({ dispatch, commit }, submission) {
    return apiService.updateSubmission(submission);
  },
  resendActivation({ dispatch, commit }, username) {
    return apiService.resendActivation(username);
  },
  agreeToContract({ dispatch, commit }) {
    return apiService.agreeToContract();
  }
};

const mutations = {
  loginRequest(state: State, user: User) {
    state.status = { loggingIn: true };
    state.user = user;
  },
  loginSuccess(state: State, user: User) {
    state.status = { loggedIn: true };
    state.user = user;
  },
  loginFailure(state: State) {
    state.status = {};
    state.user = undefined;
  },
  logout(state: State) {
    state.status = {};
    state.user = undefined;
  },
  registerRequest(state: State, user: User) {
    state.status = { registering: true };
  },
  registerSuccess(state: State, user: User) {
    state.status = {};
  },
  registerFailure(state: State, user: User) {
    state.status = {};
  },
  cancelLogin(state: State) {
    state.status = {};
  },
  success(state: any, message: any) {
    state.status.unreadMsg = true;
    state.status.alert = {
      message: message?.split("\n")
    };
  },
  error(state: any, message: any) {
    state.status.unreadMsg = true;
    state.status.alert = {
      message: message?.split("\n")
    };
  },
  clear(state: any) {
    state.status.alert = undefined;
    state.status.unreadMsg = false;
    // trigger change
    state.status = Object.assign({}, state.status);
  }
};

export const api = {
  namespaced: true,
  state,
  actions,
  mutations
};
